import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

const EnergyMeteringService = new BaseService({
  api: new BaseAPI({}),
  urlParamsItems: {
    limit: 1000,
    offset: 0,
    q: { $orderby: { dt_evt: 'ASC' } },
  },
});

export default EnergyMeteringService;
